import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface Props {
  boxAlignment?: 'center' | 'flexStart'
  action?: JSX.Element
}

export const TagsContainer = ({
  boxAlignment,
  action,
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <Box
      background="grey200"
      paddingX="s32"
      paddingY="s16"
      alignItems="flexEnd"
      gap="s16"
      borderRadius={{ all: 'abs008' }}
    >
      <Box
        width="full"
        minHeight="s96"
        background="grey000White"
        gap="s8"
        flexWrap="wrap"
        flexDirection="row"
        alignItems={boxAlignment}
        justifyContent={boxAlignment}
        border={{ all: { color: 'grey400', style: 'solid', width: 's2' } }}
        borderRadius={{ all: 'abs008' }}
        padding="s16"
      >
        {children}
      </Box>
      {action}
    </Box>
  )
}
